/** @jsx jsx */
import { ClassNames, jsx } from '@emotion/react';
import ApplicationCard from 'components/ApplicationCard';
import Container from 'components/Container';
import useLocalizationContext from 'hooks/useLocalizationContext';
import React from 'react';
import { routeUrl } from 'routesBuilder';
import { ApplicationTile } from 'types/Application';

export interface AlternativesProps extends React.HTMLAttributes<HTMLDivElement> {
  alternatives: ApplicationTile[];
  title: any;
}

const Alternatives = React.forwardRef<HTMLDivElement, AlternativesProps>(({ alternatives, title }, ref) => {
  const { locale, region } = useLocalizationContext();
  return (
    <Container maxWidth='lg'>
      <ClassNames>
        {({ theme }) => (
          <div
            ref={ref}
            css={{
              alignItems: 'stretch',
              display: 'flex',
              flexDirection: 'column',
              flexGrow: 1,
              paddingTop: theme.spacing(4),
            }}
          >
            <h2
              css={{
                ...theme.typography.h2,
                '@media(min-width: 960px)': { padding: theme.spacing(0, 2) },
                marginBottom: theme.spacing(2),
                textAlign: 'left',
              }}
            >
              {title}
            </h2>
            <div
              css={{
                alignSelf: 'center',
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'center',
                maxWidth: theme.breakpoints.values.lg,
                padding: theme.spacing(1),
                width: '100%',
              }}
            >
              {alternatives.map((app, idx) => (
                <ApplicationCard
                  path={routeUrl('applicationDetail', {
                    locale,
                    params: { id: app.path, locale: locale, region: region },
                  })}
                  css={{
                    '@media(min-width: 960px)': {
                      width: 'calc(25% - 16px)',
                    },
                  }}
                  application={app}
                  key={idx.toString()}
                />
              ))}
            </div>
          </div>
        )}
      </ClassNames>
    </Container>
  );
});

export default Alternatives;
